import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
// slices
import chargerReducer from './slices/chargers';
import chargerProviderReducer from './slices/providers';
import brandReducer from './slices/brands';
import modelReducer from './slices/models';
import eletricalOutletReducer from './slices/eletricalOutlets';
import userReducer from './slices/users';
import vehicleReducer from './slices/vehicles';
import dashboardReducer from './slices/dashboards';
import settingReducer from './slices/settings';
import agentReducer from './slices/agents';
import paymentReducer from './slices/payments';
import providerGroupsReducer from './slices/providerGroups';
import creditsReducer from './slices/credits';
import walletsReducer from './slices/wallets';
import tariffsReducer from './slices/tariffs';
import ocppChargerReducer from './slices/ocppChargers';
import logsReducer from './slices/logs';
import chargingProfileReducer from './slices/chargingProfiles';
// ----------------------------------------------------------------------

const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: [],
};

const rootReducer = combineReducers({
  charger: chargerReducer,
  chargerProvider: chargerProviderReducer,
  brand: brandReducer,
  model: modelReducer,
  eletricalOutlet: eletricalOutletReducer,
  user: userReducer,
  vehicle: vehicleReducer,
  dashboard: dashboardReducer,
  setting: settingReducer,
  agent: agentReducer,
  payment: paymentReducer,
  providerGroup: providerGroupsReducer,
  credit: creditsReducer,
  wallet: walletsReducer,
  tariff: tariffsReducer,
  ocppCharger: ocppChargerReducer,
  logs: logsReducer,
  chargingProfile: chargingProfileReducer,
});

export { rootPersistConfig, rootReducer };
